<template>
  <div class="py-1">
    <div
      v-if="!isLeafNode"
      class="is-flex is-align-items-center"
    >
      <a
        class="u-clickable"
        @click="clickLink"
      >
        <span class="icon">
          <i
            v-if="isActive"
            class="fas fa-caret-down"
          ></i>
          <i
            v-else
            class="fas fa-caret-right"
          ></i>
        </span>
        <span>{{ item.label }}</span>
      </a>
      <DrillStartModal :category-slug="item.slug" />
    </div>
    <div v-else>
      <div class="is-flex is-align-items-center">
        <a
          class="u-clickable"
          @click="isActivePosts = !isActivePosts"
        >
          <span class="icon">
            <i
              v-if="isActivePosts"
              class="fas fa-caret-down"
            ></i>
            <i
              v-else
              class="fas fa-caret-right"
            ></i>
          </span>
          <span>{{ item.label }}</span>
        </a>
        <DrillStartModal :category-slug="item.slug" />
      </div>
      <div>
        <DrillPostList
          v-if="isActivePosts"
          :category-slug="item.slug"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CategoryList from '@/components/organisms/CategoryList'
import DrillPostList from '@/components/organisms/DrillPostList'
import DrillStartModal from '@/components/organisms/DrillStartModal'

export default {
  name: 'CategoryListItem',

  components: {
    CategoryList,
    DrillPostList,
    DrillStartModal,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    isLeafNode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isActivePosts: false,
    }
  },

  created() {},

  methods: {
    clickLink() {
      console.log('child:clickLink')
      this.$emit('link-click')
    },
  },
}
</script>

<style lang="scss"></style>
